import { cn } from '@/lib/utils';

type BrandMarkProps = {
  className?: string;
  /** Show product name next to the mark. */
  showName?: boolean;
  /** Compact mark for collapsed sidebars. */
  compact?: boolean;
  /** Full company logo stack (auth / marketing). */
  full?: boolean;
};

/** Same VOICERAcx mark everywhere — natural aspect ratio, never stretched. */
export function BrandMark({
  className,
  showName = true,
  compact = false,
  full = false,
}: BrandMarkProps) {
  if (full) {
    return (
      <span className={cn('inline-flex flex-col items-center gap-3', className)}>
        <img
          src="/voicera-logo.png"
          alt="VOICERAcx.ai"
          className="h-24 w-auto max-w-[14rem] object-contain"
        />
        <span className="text-lg font-bold tracking-tight text-foreground">
          VEE Connector
        </span>
      </span>
    );
  }

  return (
    <span className={cn('inline-flex min-w-0 items-center gap-2.5', className)}>
      <img
        src="/voicera-logo.png"
        alt="Voicera"
        className={cn(
          'shrink-0 object-contain',
          compact ? 'h-8 w-auto' : 'h-9 w-auto'
        )}
      />
      {showName && !compact ? (
        <span className="flex min-w-0 flex-col leading-tight">
          <span className="truncate text-sm font-bold tracking-tight text-foreground">
            VEE Connector
          </span>
          <span className="truncate text-[10px] font-medium uppercase tracking-[0.12em] text-muted-foreground">
            by VOICERAcx
          </span>
        </span>
      ) : null}
    </span>
  );
}
